export const importDataItems = [
  { title: 'Investor Entities', path: 'investorEntities' },
  { title: 'Allocations', path: 'allocations' },
  { title: 'Transactions', path: 'transactions' },
  { title: 'Valuations', path: 'valuations' }
];
